var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form",
    { attrs: { id: "source_submit" }, on: { submit: _vm.onSubmit } },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-sm-12" },
          [
            !_vm.editable
              ? _c("p", { staticClass: "alert-warning" }, [
                  _vm._v("Это не ваш источник — можно изменить только емейл.")
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-form-group",
              { attrs: { label: "Название", "label-for": "title" } },
              [
                _c("b-form-input", {
                  attrs: { id: "title", type: "text", disabled: !_vm.editable },
                  model: {
                    value: _vm.source.item.title,
                    callback: function($$v) {
                      _vm.$set(_vm.source.item, "title", $$v)
                    },
                    expression: "source.item.title"
                  }
                }),
                _vm._v(" "),
                _vm.submitted && !_vm.source.item.title
                  ? _c("span", { staticClass: "alert-danger" }, [
                      _vm._v("Заполните название")
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              { attrs: { label: "Группа" } },
              [
                _c(
                  "v-select",
                  {
                    attrs: { options: _vm.groups, disabled: !_vm.editable },
                    model: {
                      value: _vm.source.item.group,
                      callback: function($$v) {
                        _vm.$set(_vm.source.item, "group", $$v)
                      },
                      expression: "source.item.group"
                    }
                  },
                  [
                    _c(
                      "span",
                      { attrs: { slot: "no-options" }, slot: "no-options" },
                      [_vm._v("Совпадений не найдено.")]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.submitted && !_vm.source.item.group
                  ? _c("span", { staticClass: "alert-danger" }, [
                      _vm._v("Выберите группу")
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              { attrs: { label: "Валюта" } },
              [
                _c(
                  "v-select",
                  {
                    attrs: {
                      options: _vm.currency,
                      disabled: !_vm.editable,
                      required: ""
                    },
                    model: {
                      value: _vm.source.item.currency,
                      callback: function($$v) {
                        _vm.$set(_vm.source.item, "currency", $$v)
                      },
                      expression: "source.item.currency"
                    }
                  },
                  [
                    _c(
                      "span",
                      { attrs: { slot: "no-options" }, slot: "no-options" },
                      [_vm._v("Совпадений не найдено.")]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.submitted && !_vm.source.item.currency
                  ? _c("span", { staticClass: "alert-danger" }, [
                      _vm._v("Добавьте валюту")
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              { attrs: { label: "Емейл", "label-for": "email" } },
              [
                _c("b-form-input", {
                  attrs: { id: "email", type: "email" },
                  model: {
                    value: _vm.source.item.email,
                    callback: function($$v) {
                      _vm.$set(_vm.source.item, "email", $$v)
                    },
                    expression: "source.item.email"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-button",
              {
                staticClass: "float-right",
                attrs: { type: "submit", variant: "primary" }
              },
              [_vm._v("Сохранить и выйти\n            ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-errors" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0cefbe78", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cefbe78","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/front/modals/EditSourceModal.vue
// module id = 941
// module chunks = 0